export const state = () => ({
  productRecommendationList: [],
});
